/** @format */

import React, {useContext} from 'react'
import ReCAPTCHA from 'react-google-recaptcha'

import LoaderButton from '@src/components/tailwind/LoaderButton'

import ajax from '../ajax'
import Modal from '../components/tailwind/Modal'
import {AccountContext} from '../contexts/AccountContext'
import {LoadingContext} from '../contexts/LoadingContext'
import * as toast from '../toast'
import {CheckoutContext} from './CheckoutContext'
import {STEPS} from './constants'

const Formspree = window.formspree

export default function AccountModal(props) {
  const {productId, prefix, noMobileScroll} = props
  const recaptchaRef = React.createRef()
  const {ready} = useContext(LoadingContext)

  const {
    currentStep,
    nextStep,
    currentModal,
    closeModal,
    checkoutData,
    updateCheckoutData,
  } = useContext(CheckoutContext)

  const {reloadAccount} = useContext(AccountContext)

  const canRegister = () => {
    return (
      checkoutData.firstName &&
      checkoutData.lastName &&
      checkoutData.email &&
      checkoutData.password &&
      checkoutData.password === checkoutData.passwordcheck
    )
  }

  const submit = async e => {
    const token = Formspree.RECAPTCHA_ON_PLANS_PAGE_REGISTER
      ? await recaptchaRef.current.executeAsync()
      : undefined
    if (Formspree.RECAPTCHA_ON_PLANS_PAGE_REGISTER && !token) {
      toast.warning('Please check the reCaptcha field.')
    } else {
      await ajax({
        method: 'POST',
        payload: {
          'g-recaptcha-response': token,
          first_name: checkoutData.firstName,
          last_name: checkoutData.lastName,
          email: checkoutData.email,
          password: checkoutData.password,
        },
        endpoint: `/api-int/register/`,
        onSuccess: async () => {
          await reloadAccount()
          nextStep(e)
        },
        errorMsg: 'Registration failed',
      })
    }
    ready()
  }

  return (
    <Modal
      title={<h4 className={'text-xl font-bold'}>Account Details</h4>}
      isOpen={
        currentModal === prefix + productId && currentStep === STEPS.REGISTER
      }
      onClose={closeModal}
      noMobileScroll={noMobileScroll}
    >
      <form className={'grid w-full grid-cols-1 gap-x-4 sm:grid-cols-2'}>
        <div className="sm:col-span-1">
          <label>
            First Name:{' '}
            <input
              autoComplete="given-name"
              name="first_name"
              value={checkoutData.firstName}
              onChange={updateCheckoutData('firstName')}
            />
          </label>
        </div>
        <div className="sm:col-span-1">
          <label>
            Last Name:{' '}
            <input
              autoComplete="family-name"
              name="last_name"
              value={checkoutData.lastName}
              onChange={updateCheckoutData('lastName')}
            />
          </label>
        </div>
        <div className="sm:col-span-2">
          <label>
            Email:{' '}
            <input
              type="email"
              autoComplete="email"
              name="email"
              required
              value={checkoutData.email}
              onChange={updateCheckoutData('email')}
            />
          </label>
        </div>
        <div className="sm:col-span-2">
          <label>
            Password:{' '}
            <input
              type="password"
              required
              value={checkoutData.password}
              onChange={updateCheckoutData('password')}
            />
          </label>
        </div>
        <div className="sm:col-span-2">
          <label>
            Password (again):{' '}
            <input
              type="password"
              required
              value={checkoutData.passwordcheck}
              onChange={updateCheckoutData('passwordcheck')}
            />
          </label>
        </div>
        {Formspree.RECAPTCHA_ON_PLANS_PAGE_REGISTER && (
          <div className="sm:col-span-2">
            <label>
              <ReCAPTCHA
                sitekey={Formspree.RECAPTCHA_V2_INVISIBLE_KEY}
                ref={recaptchaRef}
                size="invisible"
                badge="inline"
                required
              />
            </label>
          </div>
        )}
        <div className={'right mt-6 sm:col-span-2'}>
          <LoaderButton
            onClick={submit}
            disabled={!canRegister()}
            className="buttonPrimary w-full"
          >
            Next &gt;
          </LoaderButton>
        </div>
      </form>
    </Modal>
  )
}
